import React from "react";
import { Input } from "antd";
import styled from "styled-components";

const { TextArea } = Input;

const FeedbackContainer = styled.div`
  margin-top: 32px;
  background: #fafafa;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #f0f0f0;

  .label {
    display: block;
    font-weight: 800;
    color: #595959;
    text-transform: uppercase;
    font-size: 11px;
    margin-bottom: 16px;
    letter-spacing: 1px;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
      content: "";
      width: 4px;
      height: 14px;
      background: #1890ff;
      border-radius: 2px;
    }
  }
`;

interface SubjectFeedbackProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

const SubjectFeedback: React.FC<SubjectFeedbackProps> = ({
  label,
  value,
  onChange,
}) => {
  return (
    <FeedbackContainer>
      <span className="label">Overall {label} Feedback</span>
      <TextArea
        placeholder={`Summary for ${label} section...`}
        rows={4}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ borderRadius: "12px", background: "#fcfcfc" }}
      />
    </FeedbackContainer>
  );
};

export default SubjectFeedback;
